export default __webpack_public_path__ + "static/media/three.275c36ff.jpg";